import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class AppointmentStatusService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/appointmentstatuses/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/appointmentstatuses')
            .pipe(
                map((res: any) => {
                    console.log(res);
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createAppStatus(lookup: Lookup) {
        return this.httpClient.post('api/appointmentstatuses/create', lookup.data).toPromise();
    }

    editAppStatus(lookup: Lookup) {
        return this.httpClient.post('api/appointmentstatuses/edit', lookup.data).toPromise();
    }

    deleteAppStatus(ids: Array<Number>) {
        return this.httpClient.post('api/appointmentstatuses/delete', ids).toPromise();
    }

}